import script from "./TransactionsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionsList.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionsList.vue?vue&type=style&index=0&id=900a7d7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-900a7d7c"]])

export default __exports__